import { React, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import { MentionsInput, Mention } from "react-mentions";
import { v4 as uuid } from "uuid";
import Member from "shared/media/user/userIcon.png";
import { useFormik } from "formik";
import { RenderIf, Button, File } from "shared/components";
import {
  Send,
  SendIcon,
  Bookmark,
  Like,
  CalendarSearch,
  Eye,
  DownArrow,
} from "shared/components/Icons";
import { getYearAndMonthNameAndDate } from "shared/helper/formatDate";
import {
  useDetailedInfoByIdQuery,
  useGetAllUsersQuery,
} from "redux/api/siteUsers";
import {
  useCreateCommentMutation,
  useLazyGetAllCommentsQuery,
  useDeleteNewsLikeMutation,
  useNewsLikeMutation,
} from "redux/api/news";
import {
  useBookmarkMutation,
  useDeleteBookmarkMutation,
} from "redux/api/bookmark";
import { custom, customStyleSecond } from "shared/helper/mentionStyle";
import { NewComments } from "./components";
import { initialValues, initialValues2 } from "./data";
import { SendModal } from "./modals";
import classNames from "./NewsCard.scss";

const { REACT_APP_BASE_PHOTO_URL_MAIN } = process.env;
const { REACT_APP_BASE_PHOTO_URL } = process.env;

const NewsCard = ({
  image,
  title,
  text,
  date,
  comment,
  cardClickHandler,
  newsData,
  newsId,
  refetch,
  isLiked,
  likeCount,
  viewCount,
  isBookmarked,
}) => {
  const { t } = useTranslation();
  const { id } = useSelector((state) => state.user.user);
  const { data } = useDetailedInfoByIdQuery({ id: id });
  const [toggle, setToggle] = useState(false);
  const [inputVal, setInputVal] = useState("");
  const [fileData, setFileData] = useState(null);
  const [selectedId, setSelectedId] = useState([]);
  const [suggestion, setSuggettion] = useState([]);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [modal, setModal] = useState(false);
  const { data: siteUsers, isSuccess: usersSuccess } = useGetAllUsersQuery({});
  const [createComment, { isSuccess: commentSuccess }] =
    useCreateCommentMutation();

  const [getCommentsByNews, { data: commentData, isLoading: commentLoading }] =
    useLazyGetAllCommentsQuery();
  const [newsLike, { isSuccess: likeSuccess }] = useNewsLikeMutation();
  const [deleteNewsLike, { isSuccess: deleteLikeSuccess }] =
    useDeleteNewsLikeMutation();
  const [bookmark, { isSuccess: bookmarkSuccess }] = useBookmarkMutation();
  const [deleteBookmark, { isSuccess: deleteSuccess }] =
    useDeleteBookmarkMutation();
  const handleTagClick = (id) => {
    setSelectedId((prevIds) => [...prevIds, id]);
  };

  let formattedMessage = inputVal;
  selectedId?.forEach((id, index) => {
    const regex = new RegExp(`@\\[.*?\\]\\(${id}\\)`, "g");
    formattedMessage = formattedMessage.replace(regex, `@${id}`);
  });
  const getImagesFromFile = (value) => {
    setFileData(value);
  };

  const likeNews = () => {
    const formData = new FormData();
    formData.append("NewsId", newsData);
    newsLike(formData);
  };
  const deleteLike = () => {
    const data = {
      newsId: newsData,
    };
    deleteNewsLike(data);
  };
  const saveBookmark = () => {
    const formData = new FormData();
    formData.append("NewsId", newsData);

    bookmark(formData);
  };
  const deleteBookmarked = () => {
    const data = {
      newsId: newsData,
    };
    deleteBookmark(data);
  };
  function handleLoadMore() {
    setRowsPerPage(rowsPerPage + 3);
    getCommentsByNews({
      newsId: newsId,
      skip: 0,
      take: rowsPerPage + 3,
      orderBy: false,
      sortField: "id",
    });
  }
  const formik = useFormik({
    initialValues,
    initialValues2,
    onSubmit: (values, { resetForm, setSubmitting }) => {
      if (values.submitType === "POST2") {
        const comment = new FormData();
        comment.append("newsId", newsData);
        if (inputVal) {
          comment.append("description", formattedMessage);
        }
        comment.append("siteUserId", id);
        if (fileData?.length) {
          for (let i = 0; i < fileData?.length; i++) {
            comment.append(`files`, fileData?.[i]);
          }
        } else {
          comment.append(`files`, null);
        }
        let condition = !inputVal?.trim() && !fileData?.length;
        !condition && createComment(comment);
      }

      resetForm();
    },
  });

  const textData = text
    .split("</p>")
    .filter(Boolean)
    .map((item) => item + "</p>");
  const visibleData = textData.slice(0, 1);

  useEffect(() => {
    if (commentSuccess) {
      setInputVal("");
      setFileData(null);

      refetch();
      toast.success("Send successfully !", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
    }
  }, [commentSuccess]);
  useEffect(() => {
    const formattedData = siteUsers?.data?.map((user) => ({
      id: user.id,
      display: `${user.firstName} ${user.lastName}`,
    }));
    setSuggettion(formattedData);
  }, [usersSuccess]);
  useEffect(() => {
    if (deleteSuccess || bookmarkSuccess || likeSuccess || deleteLikeSuccess) {
      refetch();
    }
  }, [deleteSuccess, bookmarkSuccess, likeSuccess, deleteLikeSuccess]);
  return (
    <div className="newsCard">
      <div onClick={cardClickHandler} className="newsCardOne">
        <div className="newsCardOneLeft">
          <img
            alt="news img"
            src={`${REACT_APP_BASE_PHOTO_URL_MAIN}${image}`}
          />
        </div>
        <div className="newsCardOneRight">
          <h4>{title}</h4>
          {visibleData?.map((item, index) => (
            <div
              className="newsCardOneRightDiv"
              key={index}
              dangerouslySetInnerHTML={{ __html: item }}
            />
          ))}

          <div className="newsCardOneRightBottom d-flex align-items-center">
            <CalendarSearch />{" "}
            <span className="mx-2">{getYearAndMonthNameAndDate(date)}</span>
          </div>
        </div>
      </div>
      <div className="newsCardTwo d-flex align-items-center justify-content-between">
        <div className="d-flex align-items-center">
          <div className="newsCardTwoIcon d-flex align-items-center">
            <Tooltip title={t("like")}>
              <div
                onClick={isLiked ? deleteLike : likeNews}
                className={`${
                  isLiked ? "like-active" : ""
                } d-flex align-items-center`}>
                <Like />
                <div className="d-flex align-items-center">
                  <span> {t("like")}</span>
                  <span>({likeCount})</span>
                </div>
              </div>
            </Tooltip>
          </div>
          <Tooltip title={t("share")}>
            <div onClick={() => setModal(true)} className="newsCardTwoIcon">
              <SendIcon />
              <span> {t("share")}</span>
            </div>
          </Tooltip>
          <Tooltip title={t("comment")}>
            <div
              onClick={() => {
                setToggle(!toggle);
                getCommentsByNews({
                  newsId: newsId,
                  skip: 0,
                  take: rowsPerPage,
                  orderBy: false,
                  sortField: "id",
                });
              }}
              className="newsCardTwoIcon">
              <Send />
              <span>
                {t("comment")} ({comment?.length})
              </span>
            </div>
          </Tooltip>
          <Tooltip title={t("Bookmark")}>
            <div
              onClick={isBookmarked ? deleteBookmarked : saveBookmark}
              className={`${
                isBookmarked ? "like-active" : ""
              } newsCardTwoIcon`}>
              <Bookmark />
              <span> {t("Bookmark")}</span>
            </div>
          </Tooltip>
        </div>
        <div className="d-flex align-items-center newsCardOneRightBottomIcon mx-2">
          <Eye />{" "}
          <span className="mx-2">
            {viewCount} {t("view")}
          </span>
        </div>
      </div>
      <form onSubmit={formik.handleSubmit}>
        <RenderIf condition={toggle}>
          <div className="newsCardComment">
            <div className="newsCardCommentInput d-flex">
              <div className="newsCardCommentInputLeft">
                <img
                  alt="user"
                  src={
                    data?.profilePhotoUrl
                      ? `${REACT_APP_BASE_PHOTO_URL}${data?.profilePhotoUrl}`
                      : Member
                  }
                />
              </div>
              <div className="newsCardCommentInputRight">
                <MentionsInput
                  autoFocus={false}
                  value={inputVal}
                  onChange={(e) => setInputVal(e.target.value)}
                  placeholder={t("writeComment")}
                  style={customStyleSecond}
                  classNames={classNames}>
                  <Mention
                    key={() => uuid()}
                    trigger="@"
                    data={suggestion}
                    onAdd={handleTagClick}
                    style={custom}
                  />
                </MentionsInput>

                <File
                  commentSuccess={commentSuccess}
                  handleImageFile={getImagesFromFile}
                />
                <button
                  className="sendButton"
                  onClick={() => formik.setFieldValue("submitType", "POST2")}
                  type="submit">
                  <SendIcon />
                </button>
              </div>
            </div>

            {commentData?.map((c) => (
              <NewComments
                key={c?.id}
                newsId={newsId}
                isLiked={c?.isLiked}
                likeCount={c?.likeCount}
                getCommentsByNews={getCommentsByNews}
                commentId={c?.id}
                rowsPerPage={rowsPerPage}
                siteUserId={c?.siteUserId}
                description={c?.description}
                userName={c?.siteUserName}
                userPhoto={c?.siteUserFileUrl}
                newsData={newsData}
                createDate={c?.createdDate}
                newsCommentFiles={c?.newsCommentFiles}
                refetch={refetch}
              />
            ))}
            <RenderIf condition={commentData?.length}>
              <Button
                onClick={handleLoadMore}
                className="showMoreButton mt-3"
                marginRight="8px"
                icon={<DownArrow />}>
                {t("showMore")}
              </Button>
            </RenderIf>
          </div>
        </RenderIf>
      </form>
      <SendModal id={newsData} modal={modal} setModal={setModal} />
    </div>
  );
};

export default NewsCard;
